import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w-100 verify-card" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = { class: "pb-3" }
const _hoisted_4 = { class: "fw-bold d-flex align-items-center text-dark ms-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-lg-12 mb-5" }
const _hoisted_8 = { class: "form-label fs-6 fw-bold text-dark required" }
const _hoisted_9 = { class: "fv-plugins-message-container" }
const _hoisted_10 = { class: "fv-help-block" }
const _hoisted_11 = { class: "col-lg-12 mb-5" }
const _hoisted_12 = { class: "form-label fw-bold text-dark fs-6 required" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = ["for"]
const _hoisted_15 = { class: "d-block fw-semobold text-start" }
const _hoisted_16 = { class: "fw-bold d-block fs-4 mb-2" }
const _hoisted_17 = { class: "col-lg-12 mb-5" }
const _hoisted_18 = { class: "form-label fw-bold text-dark fs-6 required" }
const _hoisted_19 = { class: "row" }
const _hoisted_20 = ["for"]
const _hoisted_21 = { class: "d-block fw-semobold text-start" }
const _hoisted_22 = { class: "fw-bold d-block fs-4 mb-2" }
const _hoisted_23 = { class: "col-lg-12 mb-5" }
const _hoisted_24 = { class: "form-label fw-bold text-dark fs-6 required" }
const _hoisted_25 = { class: "row" }
const _hoisted_26 = ["for"]
const _hoisted_27 = { class: "d-block fw-semobold text-start" }
const _hoisted_28 = { class: "fw-bold d-block fs-4 mb-2" }
const _hoisted_29 = {
  key: 0,
  class: "col-lg-12 mb-5"
}
const _hoisted_30 = { class: "form-label fw-bold text-dark fs-6 required" }
const _hoisted_31 = { class: "row" }
const _hoisted_32 = ["for"]
const _hoisted_33 = { class: "d-block fw-semobold text-start" }
const _hoisted_34 = { class: "fw-bold d-block fs-4 mb-2" }
const _hoisted_35 = {
  key: 0,
  class: "col-lg-12 mb-5"
}
const _hoisted_36 = { class: "form-label fs-6 fw-bold text-dark required" }
const _hoisted_37 = {
  key: 1,
  class: "col-lg-12 mb-5"
}
const _hoisted_38 = { class: "form-label fw-bold text-dark fs-6 required" }
const _hoisted_39 = { class: "row" }
const _hoisted_40 = ["for"]
const _hoisted_41 = { class: "d-block fw-semobold text-start" }
const _hoisted_42 = { class: "fw-bold d-block fs-4 mb-2" }
const _hoisted_43 = {
  key: 0,
  class: "w-100 my-5 verify-card"
}
const _hoisted_44 = { class: "" }
const _hoisted_45 = { class: "pb-3" }
const _hoisted_46 = { class: "fw-bold d-flex align-items-center text-dark ms-3" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_48 = { class: "row" }
const _hoisted_49 = { class: "col-lg-12 mb-5" }
const _hoisted_50 = { class: "form-label fw-bold text-dark fs-6 required" }
const _hoisted_51 = { class: "row" }
const _hoisted_52 = ["for"]
const _hoisted_53 = { class: "d-block fw-semobold text-start" }
const _hoisted_54 = { class: "fw-bold d-block fs-4 mb-2" }
const _hoisted_55 = { class: "col-lg-12 mb-5" }
const _hoisted_56 = { class: "form-label fw-bold text-dark fs-6 required" }
const _hoisted_57 = { class: "row" }
const _hoisted_58 = ["for"]
const _hoisted_59 = { class: "d-block fw-semobold text-start" }
const _hoisted_60 = { class: "fw-bold d-block fs-4 mb-2" }
const _hoisted_61 = { class: "col-lg-12 mb-5" }
const _hoisted_62 = { class: "form-label fw-bold text-dark fs-6 required" }
const _hoisted_63 = { class: "row" }
const _hoisted_64 = ["for"]
const _hoisted_65 = { class: "d-block fw-semobold text-start" }
const _hoisted_66 = { class: "fw-bold d-block fs-4 mb-2" }
const _hoisted_67 = { class: "col-lg-12 mb-5" }
const _hoisted_68 = { class: "form-label fw-bold text-dark fs-6 required" }
const _hoisted_69 = { class: "row" }
const _hoisted_70 = ["for"]
const _hoisted_71 = { class: "d-block fw-semobold text-start" }
const _hoisted_72 = { class: "fw-bold d-block fs-4 mb-2" }
const _hoisted_73 = { class: "w-100 my-5 verify-card" }
const _hoisted_74 = { class: "" }
const _hoisted_75 = { class: "pb-3" }
const _hoisted_76 = { class: "fw-bold d-flex align-items-center text-dark ms-3" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_78 = { class: "row" }
const _hoisted_79 = { class: "col-lg-12 mb-5" }
const _hoisted_80 = { class: "form-label fw-bold text-dark fs-6 required" }
const _hoisted_81 = { class: "row" }
const _hoisted_82 = { class: "col-6 col-lg-2" }
const _hoisted_83 = {
  class: "btn btn-outline btn-outline-default p-3 d-flex align-items-center",
  for: "bg1_yes"
}
const _hoisted_84 = { class: "d-block fw-semobold text-start" }
const _hoisted_85 = { class: "fw-bold d-block fs-4 mb-2" }
const _hoisted_86 = { class: "col-6 col-lg-2" }
const _hoisted_87 = {
  class: "btn btn-outline btn-outline-default p-3 d-flex align-items-center",
  for: "bg1_no"
}
const _hoisted_88 = { class: "d-block fw-semobold text-start" }
const _hoisted_89 = { class: "fw-bold d-block fs-4 mb-2" }
const _hoisted_90 = { class: "col-lg-12 mb-5" }
const _hoisted_91 = { class: "form-label fw-bold text-dark fs-6 required" }
const _hoisted_92 = { class: "row" }
const _hoisted_93 = { class: "col-6 col-lg-2" }
const _hoisted_94 = {
  class: "btn btn-outline btn-outline-default p-3 d-flex align-items-center",
  for: "bg2_yes"
}
const _hoisted_95 = { class: "d-block fw-semobold text-start" }
const _hoisted_96 = { class: "fw-bold d-block fs-4 mb-2" }
const _hoisted_97 = { class: "col-6 col-lg-2" }
const _hoisted_98 = {
  class: "btn btn-outline btn-outline-default p-3 d-flex align-items-center",
  for: "bg2_no"
}
const _hoisted_99 = { class: "d-block fw-semobold text-start" }
const _hoisted_100 = { class: "fw-bold d-block fs-4 mb-2" }
const _hoisted_101 = { class: "w-100 verify-card" }
const _hoisted_102 = { class: "" }
const _hoisted_103 = { class: "pb-3" }
const _hoisted_104 = { class: "fw-bold d-flex align-items-center text-dark ms-3" }
const _hoisted_105 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_106 = { class: "row" }
const _hoisted_107 = { class: "col-lg-12 mb-5" }
const _hoisted_108 = { class: "form-label fw-bold text-dark fs-6 required" }
const _hoisted_109 = { class: "row" }
const _hoisted_110 = { class: "col-6 col-lg-2" }
const _hoisted_111 = {
  class: "btn btn-outline btn-outline-default p-3 d-flex align-items-center",
  for: "exp1_true"
}
const _hoisted_112 = { class: "d-block fw-semobold text-start" }
const _hoisted_113 = { class: "fw-bold d-block fs-4 mb-2" }
const _hoisted_114 = { class: "col-6 col-lg-2" }
const _hoisted_115 = {
  class: "btn btn-outline btn-outline-default p-3 d-flex align-items-center",
  for: "exp1_false"
}
const _hoisted_116 = { class: "d-block fw-semobold text-start" }
const _hoisted_117 = { class: "fw-bold d-block fs-4 mb-2" }
const _hoisted_118 = {
  key: 0,
  class: "col-lg-12 mb-5"
}
const _hoisted_119 = { class: "form-label fs-6 fw-bold text-dark required" }
const _hoisted_120 = { class: "fv-plugins-message-container" }
const _hoisted_121 = { class: "fv-help-block" }
const _hoisted_122 = {
  key: 1,
  class: "col-lg-12 mb-5"
}
const _hoisted_123 = { class: "form-label fs-6 fw-bold text-dark required" }
const _hoisted_124 = { class: "fv-plugins-message-container" }
const _hoisted_125 = { class: "fv-help-block" }
const _hoisted_126 = {
  key: 2,
  class: "col-lg-12 mb-5"
}
const _hoisted_127 = { class: "form-label fs-6 fw-bold text-dark required" }
const _hoisted_128 = { class: "fv-plugins-message-container" }
const _hoisted_129 = { class: "fv-help-block" }
const _hoisted_130 = { class: "form-label fw-bold text-dark fs-6 required" }
const _hoisted_131 = { class: "row" }
const _hoisted_132 = { class: "col-6 col-lg-2" }
const _hoisted_133 = ["for"]
const _hoisted_134 = { class: "d-block fw-semobold text-start" }
const _hoisted_135 = { class: "fw-bold d-block fs-4 mb-2" }
const _hoisted_136 = { class: "col-6 col-lg-2" }
const _hoisted_137 = ["for"]
const _hoisted_138 = { class: "d-block fw-semobold text-start" }
const _hoisted_139 = { class: "fw-bold d-block fs-4 mb-2" }
const _hoisted_140 = {
  key: 0,
  class: "col-lg-12 mt-10 ms-3"
}
const _hoisted_141 = { class: "form-label fs-6 fw-bold text-dark required" }
const _hoisted_142 = { class: "fv-plugins-message-container" }
const _hoisted_143 = { class: "fv-help-block" }

import { computed, ref, watch, onMounted } from "vue";
import { ErrorMessage, Field } from "vee-validate";
import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserFinancial',
  props: {
    verificationDetails: {}
  },
  setup(__props: any) {

const props = __props;

const isSubmit = ref(false);
const { t } = useI18n();

const show_exp1_more = ref(false);
const hasOtherFund = ref(false);
const otherFunds = ref<string>("");
const handleOtherFundsInputBlurred = () => {
  const otherFundsList = otherFunds.value
    .split(",")
    .map((x) => x.trim())
    .filter((y) => y !== "");
  item.value.fund = [...new Set([...item.value.fund, ...otherFundsList])];
};

const range_section = computed(() => ({
  range_1: {
    id: "range_1",
    text: "> $450,000",
    value: "1",
  },
  range_2: {
    id: "range_2",
    text: "$200,000 - $449,999",
    value: "2",
  },
  range_3: {
    id: "range_3",
    text: "$90,000 - $199,999",
    value: "3",
  },
  range_4: {
    id: "range_4",
    text: "$60,000 - 89,999",
    value: "4",
  },
  range_5: {
    id: "range_5",
    text: "$15,000 - 59,999",
    value: "5",
  },
  range_6: {
    id: "range_6",
    text: "< $15,000",
    value: "6",
  },
}));

const position = computed(() => ({
  pos_1: {
    id: "pos_1",
    text: t("fields.director"),
    value: "director",
  },
  pos_2: {
    id: "pos_2",
    text: t("fields.manager"),
    value: "manager",
  },
  pos_3: {
    id: "pos_3",
    text: t("fields.entryLevel"),
    value: "entry_level",
  },
  pos_4: {
    id: "pos_4",
    text: t("fields.other"),
    value: "other",
  },
}));

const funds = computed(() => ({
  fund_1: {
    id: "fund_1",
    text: t("fields.employment"),
    value: "employment",
  },
  fund_2: {
    id: "fund_2",
    text: t("fields.inheritance"),
    value: "inheritance",
  },
  fund_3: {
    id: "fund_3",
    text: t("fields.savingAndInvestment"),
    value: "saving_and_investment",
  },
  fund_4: {
    id: "fund_4",
    text: t("fields.other"),
    value: "other",
  },
}));

const trading_exp = computed(() => ({
  exp2: {
    id: "exp2",
    text: t("tip.verificationFinancialHaveBankruptcy"),
    show_more: false,
    more_question: t("tip.verificationFinancialIndicateDischarge"),
  },
  exp3: {
    id: "exp3",
    text: t("tip.verificationFinancialAnyPersonOfCommodityOrRegulatory"),
    show_more: false,
    more_question: t("tip.verificationFinancialProvideExchangeOrAgency"),
  },
  exp4: {
    id: "exp4",
    text: t("tip.verificationFinancialAreYouPep"),
    show_more: false,
    more_question: t("tip.yesProvideDetails"),
  },
  exp5: {
    id: "exp5",
    text: t("tip.verificationFinancialAreYouAssociate"),
    show_more: false,
    more_question: t("tip.yesProvideDetails"),
  },
}));

const funds2 = computed(() => ({
  fund1: {
    id: "fund1",
    text: t("type.verification.financial.fund1"), // Salary or employment income
    value: "fund1",
  },
  fund2: {
    id: "fund2",
    text: t("type.verification.financial.fund2"), // Business income
    value: "fund2",
  },
  fund3: {
    id: "fund3",
    text: t("type.verification.financial.fund3"), // Investment income
    value: "fund3",
  },
  fund4: {
    id: "fund4",
    text: t("type.verification.financial.fund4"), // Sale of property or other assets
    value: "fund4",
  },
  fund5: {
    id: "fund5",
    text: t("type.verification.financial.fund5"), // Inheritance or family wealth
    value: "fund5",
  },
  fund6: {
    id: "fund6",
    text: t("type.verification.financial.fund6"), // Savings accumulated over time
    value: "fund6",
  },
  fund7: {
    id: "fund7",
    text: t("type.verification.financial.fund7"), // Pension or retirement income
    value: "fund7",
  },
  fund8: {
    id: "fund8",
    text: t("type.verification.financial.fund8"), // Loan or credit facility
    value: "fund8",
  },
  fund9: {
    id: "fund9",
    text: t("type.verification.financial.fund9"), // Gift from family or third party
    value: "fund9",
  },
}));

const natureOfTransactions = computed(() => ({
  txn1: { id: "txn1", text: t("type.verification.nature.txn1"), value: "txn1" }, // Spot FOREX trading
  txn2: { id: "txn2", text: t("type.verification.nature.txn2"), value: "txn2" }, // CFDs on indices, commodities, shares
  txn3: { id: "txn3", text: t("type.verification.nature.txn3"), value: "txn3" }, // Precious metals trading
  txn4: { id: "txn4", text: t("type.verification.nature.txn4"), value: "txn4" }, // Margin/leveraged transactions
  txn5: { id: "txn5", text: t("type.verification.nature.txn5"), value: "txn5" }, // Hedging / risk management
  txn6: { id: "txn6", text: t("type.verification.nature.txn6"), value: "txn6" }, // Short-term speculative trading
  txn7: { id: "txn7", text: t("type.verification.nature.txn7"), value: "txn7" }, // Long-term investment trading
}));

const expectedAvgTradeSizes = computed(() => ({
  size1: {
    id: "size1",
    text: t("type.verification.expected.size1"),
    value: "size1",
  }, // < 5k
  size2: {
    id: "size2",
    text: t("type.verification.expected.size2"),
    value: "size2",
  }, // 5,001–25k
  size3: {
    id: "size3",
    text: t("type.verification.expected.size3"),
    value: "size3",
  }, // 25,001–100k
  size4: {
    id: "size4",
    text: t("type.verification.expected.size4"),
    value: "size4",
  }, // > 100k
}));

const expectedMonthlyVolume = computed(() => ({
  vol1: {
    id: "vol1",
    text: t("type.verification.expected.vol1"),
    value: "vol1",
  }, // < 10k
  vol2: {
    id: "vol2",
    text: t("type.verification.expected.vol2"),
    value: "vol2",
  }, // 10,001–50k
  vol3: {
    id: "vol3",
    text: t("type.verification.expected.vol3"),
    value: "vol3",
  }, // 50,001–250k
  vol4: {
    id: "vol4",
    text: t("type.verification.expected.vol4"),
    value: "vol4",
  }, // 250,001–1,000,000
  vol5: {
    id: "vol5",
    text: t("type.verification.expected.vol5"),
    value: "vol5",
  }, // > 1,000,000
}));

const expectedFrequency = computed(() => ({
  freq1: {
    id: "freq1",
    text: t("type.verification.expected.freq1"),
    value: "freq1",
  }, // Occasional
  freq2: {
    id: "freq2",
    text: t("type.verification.expected.freq2"),
    value: "freq2",
  }, // Moderate
  freq3: {
    id: "freq3",
    text: t("type.verification.expected.freq3"),
    value: "freq3",
  }, // Frequent
}));



const item = ref<any>({
  ...props.verificationDetails?.financial,
});

const initHasOtherFund = () => {
  const defaultFunds = Object.keys(funds.value).map(
    (x) => funds.value[x].value
  );
  hasOtherFund.value = item.value.fund?.some(
    (x: string) => x === funds.value.fund_4.value
  );
  if (!hasOtherFund.value) {
    otherFunds.value = "";
    item.value.fund = item.value.fund?.filter((x: string) =>
      defaultFunds.includes(x)
    );
    return;
  }
  otherFunds.value = item.value.fund
    ?.filter((x: string) => !defaultFunds.includes(x))
    .join(", ");
};

onMounted(() => {
  initHasOtherFund();
});

watch(
  () => props.verificationDetails,
  () => {
    item.value = {
      ...props.verificationDetails?.financial,
    };
  }
);

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t("title.financial")), 1)
        ]),
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t("fields.industry")), 1),
            _createVNode(_unref(Field), {
              modelValue: item.value.industry,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((item.value.industry) = $event)),
              tabindex: "3",
              class: "form-control form-control-lg form-control-solid",
              name: "industry"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: item.value.industry,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((item.value.industry) = $event)),
                  name: "industry",
                  size: "large"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      value: _ctx.$t('fields.government')
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("fields.government")), 1)
                      ]),
                      _: 1
                    }, 8, ["value"]),
                    _createVNode(_component_el_option, {
                      value: _ctx.$t('fields.accounting')
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("fields.accounting")), 1)
                      ]),
                      _: 1
                    }, 8, ["value"]),
                    _createVNode(_component_el_option, {
                      value: _ctx.$t('fields.banking')
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("fields.banking")), 1)
                      ]),
                      _: 1
                    }, 8, ["value"]),
                    _createVNode(_component_el_option, {
                      value: _ctx.$t('fields.finance')
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("fields.finance")), 1)
                      ]),
                      _: 1
                    }, 8, ["value"]),
                    _createVNode(_component_el_option, {
                      value: _ctx.$t('fields.insurance')
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("fields.insurance")), 1)
                      ]),
                      _: 1
                    }, 8, ["value"]),
                    _createVNode(_component_el_option, {
                      value: _ctx.$t('fields.other')
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("fields.other")), 1)
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_unref(ErrorMessage), { name: "industry" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t("fields.position")), 1),
            _createElementVNode("div", _hoisted_13, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(position.value, (v_item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "col-lg-3 mb-3"
                }, [
                  _createVNode(_unref(Field), {
                    modelValue: item.value.position,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((item.value.position) = $event)),
                    type: "radio",
                    class: "btn-check",
                    name: "position",
                    value: v_item.value,
                    id: v_item.id
                  }, null, 8, ["modelValue", "value", "id"]),
                  _createElementVNode("label", {
                    class: "btn btn-outline btn-outline-default p-2 d-flex align-items-center",
                    for: v_item.id
                  }, [
                    _createElementVNode("span", _hoisted_15, [
                      _createElementVNode("span", _hoisted_16, _toDisplayString(v_item.text), 1)
                    ])
                  ], 8, _hoisted_14)
                ]))
              }), 128)),
              _createVNode(_unref(ErrorMessage), {
                name: "position",
                class: "fv-plugins-message-container invalid-feedback"
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t("fields.annualIncome")), 1),
            _createElementVNode("div", _hoisted_19, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(range_section.value, (v_item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "col-lg-4 mb-3"
                }, [
                  _createVNode(_unref(Field), {
                    modelValue: item.value.income,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((item.value.income) = $event)),
                    type: "radio",
                    class: "btn-check",
                    name: "income",
                    value: v_item.value,
                    id: v_item.id + 'income'
                  }, null, 8, ["modelValue", "value", "id"]),
                  _createElementVNode("label", {
                    class: "btn btn-outline btn-outline-default p-2 d-flex align-items-center",
                    for: v_item.id + 'income'
                  }, [
                    _createElementVNode("span", _hoisted_21, [
                      _createElementVNode("span", _hoisted_22, _toDisplayString(v_item.text), 1)
                    ])
                  ], 8, _hoisted_20)
                ]))
              }), 128)),
              _createVNode(_unref(ErrorMessage), {
                name: "income",
                class: "fv-plugins-message-container invalid-feedback"
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t("fields.valueOfInvestment")), 1),
            _createElementVNode("div", _hoisted_25, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(range_section.value, (v_item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "col-lg-4 mb-3"
                }, [
                  _createVNode(_unref(Field), {
                    modelValue: item.value.investment,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((item.value.investment) = $event)),
                    type: "radio",
                    class: "btn-check",
                    name: "investment",
                    value: v_item.value,
                    id: v_item.id + 'investment'
                  }, null, 8, ["modelValue", "value", "id"]),
                  _createElementVNode("label", {
                    class: "btn btn-outline btn-outline-default p-2 d-flex align-items-center",
                    for: v_item.id + 'investment'
                  }, [
                    _createElementVNode("span", _hoisted_27, [
                      _createElementVNode("span", _hoisted_28, _toDisplayString(v_item.text), 1)
                    ])
                  ], 8, _hoisted_26)
                ]))
              }), 128)),
              _createVNode(_unref(ErrorMessage), {
                name: "investment",
                class: "fv-plugins-message-container invalid-feedback"
              })
            ])
          ]),
          (item.value.fund !== null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.$t("fields.howToFundTrading")), 1),
                _createElementVNode("div", _hoisted_31, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(funds.value, (v_item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "col-lg-3 mb-3"
                    }, [
                      _createVNode(_unref(Field), {
                        modelValue: item.value.fund,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((item.value.fund) = $event)),
                        type: "checkbox",
                        class: "btn-check",
                        name: "fund",
                        value: v_item.value,
                        id: v_item.id
                      }, null, 8, ["modelValue", "value", "id"]),
                      _createElementVNode("label", {
                        class: "btn btn-outline btn-outline-default p-2 d-flex align-items-center",
                        for: v_item.id
                      }, [
                        _createElementVNode("span", _hoisted_33, [
                          _createElementVNode("span", _hoisted_34, _toDisplayString(v_item.text), 1)
                        ])
                      ], 8, _hoisted_32)
                    ]))
                  }), 128)),
                  (hasOtherFund.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                        _createElementVNode("label", _hoisted_36, _toDisplayString(_ctx.$t("fields.other")), 1),
                        _createVNode(_unref(Field), {
                          modelValue: otherFunds.value,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((otherFunds).value = $event)),
                          tabindex: "2",
                          type: "text",
                          name: "other-funds",
                          autocomplete: "off"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: otherFunds.value,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((otherFunds).value = $event)),
                              tabindex: "2",
                              type: "text",
                              name: "other-funds",
                              placeholder: _ctx.$t('tip.useSemicolonSeparate'),
                              autocomplete: "off",
                              size: "large",
                              onBlur: handleOtherFundsInputBlurred
                            }, null, 8, ["modelValue", "placeholder"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_unref(ErrorMessage), {
                    name: "fund",
                    class: "fv-plugins-message-container invalid-feedback"
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (item.value.fund2 !== null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                _createElementVNode("label", _hoisted_38, _toDisplayString(_ctx.$t("fields.howToFundTrading")), 1),
                _createElementVNode("div", _hoisted_39, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(funds2.value, (v_item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "col-lg-3 mb-3"
                    }, [
                      _createVNode(_unref(Field), {
                        modelValue: item.value.fund2,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((item.value.fund2) = $event)),
                        type: "checkbox",
                        class: "btn-check",
                        name: "fund",
                        value: v_item.value,
                        id: v_item.id
                      }, null, 8, ["modelValue", "value", "id"]),
                      _createElementVNode("label", {
                        class: "btn btn-outline btn-outline-default p-2 d-flex align-items-center",
                        for: v_item.id
                      }, [
                        _createElementVNode("span", _hoisted_41, [
                          _createElementVNode("span", _hoisted_42, _toDisplayString(v_item.text), 1)
                        ])
                      ], 8, _hoisted_40)
                    ]))
                  }), 128)),
                  _createVNode(_unref(ErrorMessage), {
                    name: "fund",
                    class: "fv-plugins-message-container invalid-feedback"
                  })
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    (item.value.transaction1 !== null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("h2", _hoisted_46, _toDisplayString(_ctx.$t("fields.expectedNatureAndLevelOfTransactions")), 1)
            ]),
            _hoisted_47,
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("label", _hoisted_50, _toDisplayString(_ctx.$t("fields.natureOfTransactions")), 1),
                _createElementVNode("div", _hoisted_51, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(natureOfTransactions.value, (v_item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "col-lg-3 mb-3"
                    }, [
                      _createVNode(_unref(Field), {
                        modelValue: item.value.nature,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((item.value.nature) = $event)),
                        type: "checkbox",
                        class: "btn-check",
                        name: "fund",
                        value: v_item.value,
                        id: v_item.id
                      }, null, 8, ["modelValue", "value", "id"]),
                      _createElementVNode("label", {
                        class: "btn btn-outline btn-outline-default p-2 d-flex align-items-center",
                        for: v_item.id
                      }, [
                        _createElementVNode("span", _hoisted_53, [
                          _createElementVNode("span", _hoisted_54, _toDisplayString(v_item.text), 1)
                        ])
                      ], 8, _hoisted_52)
                    ]))
                  }), 128)),
                  _createVNode(_unref(ErrorMessage), {
                    name: "bg1",
                    class: "fv-plugins-message-container invalid-feedback"
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_55, [
                _createElementVNode("label", _hoisted_56, _toDisplayString(_ctx.$t("fields.averageTradeSize")), 1),
                _createElementVNode("div", _hoisted_57, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(expectedAvgTradeSizes.value, (v_item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "col-lg-4 mb-3"
                    }, [
                      _createVNode(_unref(Field), {
                        modelValue: item.value.transaction1,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((item.value.transaction1) = $event)),
                        type: "radio",
                        class: "btn-check",
                        name: "transaction1",
                        value: v_item.value,
                        id: v_item.id + 'transaction1'
                      }, null, 8, ["modelValue", "value", "id"]),
                      _createElementVNode("label", {
                        class: "btn btn-outline btn-outline-default p-2 d-flex align-items-center",
                        for: v_item.id + 'transaction1'
                      }, [
                        _createElementVNode("span", _hoisted_59, [
                          _createElementVNode("span", _hoisted_60, _toDisplayString(v_item.text), 1)
                        ])
                      ], 8, _hoisted_58)
                    ]))
                  }), 128)),
                  _createVNode(_unref(ErrorMessage), {
                    name: "bg2",
                    class: "fv-plugins-message-container invalid-feedback"
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_61, [
                _createElementVNode("label", _hoisted_62, _toDisplayString(_ctx.$t("fields.averageTradeSize")), 1),
                _createElementVNode("div", _hoisted_63, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(expectedMonthlyVolume.value, (v_item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "col-lg-4 mb-3"
                    }, [
                      _createVNode(_unref(Field), {
                        modelValue: item.value.transaction2,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((item.value.transaction2) = $event)),
                        type: "radio",
                        class: "btn-check",
                        name: "transaction2",
                        value: v_item.value,
                        id: v_item.id + 'transaction2'
                      }, null, 8, ["modelValue", "value", "id"]),
                      _createElementVNode("label", {
                        class: "btn btn-outline btn-outline-default p-2 d-flex align-items-center",
                        for: v_item.id + 'transaction2'
                      }, [
                        _createElementVNode("span", _hoisted_65, [
                          _createElementVNode("span", _hoisted_66, _toDisplayString(v_item.text), 1)
                        ])
                      ], 8, _hoisted_64)
                    ]))
                  }), 128)),
                  _createVNode(_unref(ErrorMessage), {
                    name: "bg2",
                    class: "fv-plugins-message-container invalid-feedback"
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_67, [
                _createElementVNode("label", _hoisted_68, _toDisplayString(_ctx.$t("fields.averageTradeSize")), 1),
                _createElementVNode("div", _hoisted_69, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(expectedFrequency.value, (v_item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "col-lg-4 mb-3"
                    }, [
                      _createVNode(_unref(Field), {
                        modelValue: item.value.transaction3,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((item.value.transaction3) = $event)),
                        type: "radio",
                        class: "btn-check",
                        name: "transaction3",
                        value: v_item.value,
                        id: v_item.id + 'transaction3'
                      }, null, 8, ["modelValue", "value", "id"]),
                      _createElementVNode("label", {
                        class: "btn btn-outline btn-outline-default p-2 d-flex align-items-center",
                        for: v_item.id + 'transaction3'
                      }, [
                        _createElementVNode("span", _hoisted_71, [
                          _createElementVNode("span", _hoisted_72, _toDisplayString(v_item.text), 1)
                        ])
                      ], 8, _hoisted_70)
                    ]))
                  }), 128)),
                  _createVNode(_unref(ErrorMessage), {
                    name: "bg2",
                    class: "fv-plugins-message-container invalid-feedback"
                  })
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_73, [
      _createElementVNode("div", _hoisted_74, [
        _createElementVNode("div", _hoisted_75, [
          _createElementVNode("h2", _hoisted_76, _toDisplayString(_ctx.$t("title.tradingBackground")), 1)
        ]),
        _hoisted_77,
        _createElementVNode("div", _hoisted_78, [
          _createElementVNode("div", _hoisted_79, [
            _createElementVNode("label", _hoisted_80, _toDisplayString(_ctx.$t("tip.verificationFinancialHaveEducation")), 1),
            _createElementVNode("div", _hoisted_81, [
              _createElementVNode("div", _hoisted_82, [
                _createVNode(_unref(Field), {
                  modelValue: item.value.bg1,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((item.value.bg1) = $event)),
                  type: "radio",
                  class: "btn-check",
                  name: "bg1",
                  value: "0",
                  id: "bg1_yes"
                }, null, 8, ["modelValue"]),
                _createElementVNode("label", _hoisted_83, [
                  _createElementVNode("span", _hoisted_84, [
                    _createElementVNode("span", _hoisted_85, _toDisplayString(_ctx.$t("action.yes")), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_86, [
                _createVNode(_unref(Field), {
                  modelValue: item.value.bg1,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((item.value.bg1) = $event)),
                  type: "radio",
                  class: "btn-check",
                  name: "bg1",
                  value: "1",
                  id: "bg1_no"
                }, null, 8, ["modelValue"]),
                _createElementVNode("label", _hoisted_87, [
                  _createElementVNode("span", _hoisted_88, [
                    _createElementVNode("span", _hoisted_89, _toDisplayString(_ctx.$t("action.no")), 1)
                  ])
                ])
              ]),
              _createVNode(_unref(ErrorMessage), {
                name: "bg1",
                class: "fv-plugins-message-container invalid-feedback"
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_90, [
            _createElementVNode("label", _hoisted_91, _toDisplayString(_ctx.$t("tip.verificationFinancialHaveTradeAccount")), 1),
            _createElementVNode("div", _hoisted_92, [
              _createElementVNode("div", _hoisted_93, [
                _createVNode(_unref(Field), {
                  modelValue: item.value.bg2,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((item.value.bg2) = $event)),
                  type: "radio",
                  class: "btn-check",
                  name: "bg2",
                  value: "0",
                  id: "bg2_yes"
                }, null, 8, ["modelValue"]),
                _createElementVNode("label", _hoisted_94, [
                  _createElementVNode("span", _hoisted_95, [
                    _createElementVNode("span", _hoisted_96, _toDisplayString(_ctx.$t("action.yes")), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_97, [
                _createVNode(_unref(Field), {
                  modelValue: item.value.bg2,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((item.value.bg2) = $event)),
                  type: "radio",
                  class: "btn-check",
                  name: "bg2",
                  value: "1",
                  id: "bg2_no"
                }, null, 8, ["modelValue"]),
                _createElementVNode("label", _hoisted_98, [
                  _createElementVNode("span", _hoisted_99, [
                    _createElementVNode("span", _hoisted_100, _toDisplayString(_ctx.$t("action.no")), 1)
                  ])
                ])
              ]),
              _createVNode(_unref(ErrorMessage), {
                name: "bg2",
                class: "fv-plugins-message-container invalid-feedback"
              })
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_101, [
      _createElementVNode("div", _hoisted_102, [
        _createElementVNode("div", _hoisted_103, [
          _createElementVNode("h2", _hoisted_104, _toDisplayString(_ctx.$t("title.relevantTradingExperience")), 1)
        ]),
        _hoisted_105,
        _createElementVNode("div", _hoisted_106, [
          _createElementVNode("div", _hoisted_107, [
            _createElementVNode("label", _hoisted_108, _toDisplayString(_ctx.$t("tip.verificationFinancialAreYouBcrEmployee")), 1),
            _createElementVNode("div", _hoisted_109, [
              _createElementVNode("div", _hoisted_110, [
                _createVNode(_unref(Field), {
                  modelValue: item.value.exp1,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((item.value.exp1) = $event)),
                  type: "radio",
                  class: "btn-check",
                  name: "exp1",
                  value: "0",
                  id: "exp1_true",
                  onClick: _cache[18] || (_cache[18] = ($event: any) => (show_exp1_more.value = true))
                }, null, 8, ["modelValue"]),
                _createElementVNode("label", _hoisted_111, [
                  _createElementVNode("span", _hoisted_112, [
                    _createElementVNode("span", _hoisted_113, _toDisplayString(_ctx.$t("action.yes")), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_114, [
                _createVNode(_unref(Field), {
                  modelValue: item.value.exp1,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((item.value.exp1) = $event)),
                  type: "radio",
                  class: "btn-check",
                  name: "exp1",
                  value: "1",
                  id: "exp1_false",
                  onClick: _cache[20] || (_cache[20] = ($event: any) => (show_exp1_more.value = false))
                }, null, 8, ["modelValue"]),
                _createElementVNode("label", _hoisted_115, [
                  _createElementVNode("span", _hoisted_116, [
                    _createElementVNode("span", _hoisted_117, _toDisplayString(_ctx.$t("action.no")), 1)
                  ])
                ])
              ]),
              _createVNode(_unref(ErrorMessage), {
                name: "exp1",
                class: "fv-plugins-message-container invalid-feedback"
              })
            ])
          ]),
          (show_exp1_more.value || item.value.exp1 == '0')
            ? (_openBlock(), _createElementBlock("div", _hoisted_118, [
                _createElementVNode("label", _hoisted_119, _toDisplayString(_ctx.$t("fields.employer")), 1),
                _createVNode(_unref(Field), {
                  modelValue: item.value.exp1_employer,
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((item.value.exp1_employer) = $event)),
                  tabindex: "2",
                  type: "text",
                  name: "exp1_employer",
                  autocomplete: "off"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: item.value.exp1_employer,
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((item.value.exp1_employer) = $event)),
                      tabindex: "2",
                      type: "text",
                      name: "exp1_employer",
                      size: "large",
                      autocomplete: "off"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_120, [
                  _createElementVNode("div", _hoisted_121, [
                    _createVNode(_unref(ErrorMessage), { name: "exp1_employer" })
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (show_exp1_more.value || item.value.exp1 == '0')
            ? (_openBlock(), _createElementBlock("div", _hoisted_122, [
                _createElementVNode("label", _hoisted_123, _toDisplayString(_ctx.$t("fields.position")), 1),
                _createVNode(_unref(Field), {
                  modelValue: item.value.exp1_position,
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((item.value.exp1_position) = $event)),
                  tabindex: "2",
                  type: "text",
                  name: "exp1_position",
                  autocomplete: "off"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: item.value.exp1_position,
                      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((item.value.exp1_position) = $event)),
                      tabindex: "2",
                      type: "text",
                      name: "exp1_position",
                      autocomplete: "off",
                      size: "large"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_124, [
                  _createElementVNode("div", _hoisted_125, [
                    _createVNode(_unref(ErrorMessage), { name: "exp1_position" })
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (show_exp1_more.value || item.value.exp1 == '0')
            ? (_openBlock(), _createElementBlock("div", _hoisted_126, [
                _createElementVNode("label", _hoisted_127, _toDisplayString(_ctx.$t("fields.remuneration")), 1),
                _createVNode(_unref(Field), {
                  modelValue: item.value.exp1_remuneration,
                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((item.value.exp1_remuneration) = $event)),
                  tabindex: "2",
                  type: "text",
                  name: "exp1_remuneration",
                  autocomplete: "off"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: item.value.exp1_remuneration,
                      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((item.value.exp1_remuneration) = $event)),
                      tabindex: "2",
                      type: "text",
                      name: "exp1_remuneration",
                      autocomplete: "off",
                      size: "large"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_128, [
                  _createElementVNode("div", _hoisted_129, [
                    _createVNode(_unref(ErrorMessage), { name: "exp1_remuneration" })
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(trading_exp.value, (v_item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "col-lg-12 mb-5"
            }, [
              _createElementVNode("label", _hoisted_130, _toDisplayString(v_item.text), 1),
              _createElementVNode("div", _hoisted_131, [
                _createElementVNode("div", _hoisted_132, [
                  _createVNode(_unref(Field), {
                    modelValue: item.value[v_item.id],
                    "onUpdate:modelValue": ($event: any) => ((item.value[v_item.id]) = $event),
                    type: "radio",
                    class: "btn-check",
                    name: v_item.id,
                    value: "0",
                    id: v_item.id + '_true',
                    onClick: ($event: any) => (v_item.show_more = true)
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "name", "id", "onClick"]),
                  _createElementVNode("label", {
                    class: "btn btn-outline btn-outline-default p-3 d-flex align-items-center",
                    for: v_item.id + '_true'
                  }, [
                    _createElementVNode("span", _hoisted_134, [
                      _createElementVNode("span", _hoisted_135, _toDisplayString(_ctx.$t("action.yes")), 1)
                    ])
                  ], 8, _hoisted_133)
                ]),
                _createElementVNode("div", _hoisted_136, [
                  _createVNode(_unref(Field), {
                    modelValue: item.value[v_item.id],
                    "onUpdate:modelValue": ($event: any) => ((item.value[v_item.id]) = $event),
                    type: "radio",
                    class: "btn-check",
                    name: v_item.id,
                    value: "1",
                    id: v_item.id + '_false',
                    onClick: ($event: any) => (v_item.show_more = false)
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "name", "id", "onClick"]),
                  _createElementVNode("label", {
                    class: "btn btn-outline btn-outline-default p-3 d-flex align-items-center",
                    for: v_item.id + '_false'
                  }, [
                    _createElementVNode("span", _hoisted_138, [
                      _createElementVNode("span", _hoisted_139, _toDisplayString(_ctx.$t("action.no")), 1)
                    ])
                  ], 8, _hoisted_137)
                ]),
                _createVNode(_unref(ErrorMessage), {
                  name: v_item.id,
                  class: "fv-plugins-message-container invalid-feedback"
                }, null, 8, ["name"])
              ]),
              (v_item.show_more || item.value[v_item.id] == '0')
                ? (_openBlock(), _createElementBlock("div", _hoisted_140, [
                    _createElementVNode("label", _hoisted_141, _toDisplayString(v_item.more_question), 1),
                    _createVNode(_unref(Field), {
                      modelValue: item.value[v_item.id + '_more'],
                      "onUpdate:modelValue": ($event: any) => ((item.value[v_item.id + '_more']) = $event),
                      tabindex: "2",
                      type: "text",
                      name: v_item.id + '_more',
                      autocomplete: "off"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: item.value[v_item.id + '_more'],
                          "onUpdate:modelValue": ($event: any) => ((item.value[v_item.id + '_more']) = $event),
                          tabindex: "2",
                          type: "text",
                          name: v_item.id + '_more',
                          autocomplete: "off",
                          size: "large"
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "name"])
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "onUpdate:modelValue", "name"]),
                    _createElementVNode("div", _hoisted_142, [
                      _createElementVNode("div", _hoisted_143, [
                        _createVNode(_unref(ErrorMessage), {
                          name: v_item.id + '_more'
                        }, null, 8, ["name"])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ])
    ])
  ], 64))
}
}

})